import React, { useEffect, useState, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getToken } from "../utils/auth";
import "./StudentStudyMaterialDetail.css";


const StudentStudyMaterialDetail = () => {
  const location = useLocation();
  const { id } = useParams();

  const [material, setMaterial] = useState(
    location.state?.material || null
  );
  const [loading, setLoading] = useState(!location.state?.material);
  const [progress, setProgress] = useState(0);
  const contentRef = useRef(null);

  useEffect(() => {
    // If page refreshed → fetch again
    const fetchMaterial = async () => {
      try {
        const baseUrl =
          process.env.REACT_APP_API_BASE_URL || "http://localhost:3000";

        const res = await fetch(`${baseUrl}/getStudyMaterialById/${id}`, {
          headers: { Authorization: `Bearer ${getToken()}` }
        });
        const data = await res.json();

        setMaterial(data.material);
      } catch (err) {
        console.error("Error fetching material:", err);
      } finally {
        setLoading(false);
      }
    };

    if (!material) {
      fetchMaterial();
    }
  }, [id, material]);

  useEffect(() => {
    const updateProgress = () => {
      if (!contentRef.current) return;
      const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
      const percent = Math.max(0, Math.min(100, (scrollTop / (scrollHeight - clientHeight)) * 100));
      setProgress(Number(percent.toFixed(0)));
    };

    const container = contentRef.current;
    container?.addEventListener("scroll", updateProgress);

    return () => container?.removeEventListener("scroll", updateProgress);
  }, [material]);

  if (loading) return <div className="loading">Loading content...</div>;

  if (!material)
    return <div className="error">Material not found</div>;

  return (
    <div className="study-detail-container">
      <h1 className="title">{material.course}</h1>

      <div className="meta">
        Last updated:{" "}
        {new Date(material.updatedAt).toLocaleDateString()}
      </div>

      <div className="progress-overview">
        <span>Reading progress</span>
        <span>{progress}%</span>
      </div>
      <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${progress}%` }} />
      </div>

      <div
        ref={contentRef}
        className="content"
        dangerouslySetInnerHTML={{ __html: material.content }}
      />
    </div>
  );
};

export default StudentStudyMaterialDetail;